import React, { Component } from 'react';
import Icon from './Icon';
import DelayLink from './DelayLink';

class ProjectHeader extends Component {
	render() {
		return (
			<DelayLink
				to="/"
				className="link link--back"
				delay={300}
				onDelayStart={() => {
					document.getElementById('root').className = 'leave-to_home';
				}}
				onDelayEnd={() => {
					document.getElementById('root').className = '';
				}}
			>
				<Icon name="back" fill="#F2f2f2" title="Back icon" />
				Home
			</DelayLink>
		);
	}
}

export default ProjectHeader;
